import { render, staticRenderFns } from "./EnviosSemMovimento.vue?vue&type=template&id=bd3dcc02"
import script from "./EnviosSemMovimento.vue?vue&type=script&lang=ts"
export * from "./EnviosSemMovimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports